module.exports = __webpack_public_path__ + "static/img/ayo_2.4f3565f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ayo_2.png
// module id = HLuR
// module chunks = 1